var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuperflex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93 81H72V78C72 71.3825 66.6175 66 60 66C53.3825 66 48 71.3825 48 78H42C42 68.075 50.075 60 60 60C68.9025 60 76.3175 66.4975 77.75 75H86.835C85.3375 61.52 73.875 51 60 51C45.1125 51 33 63.1125 33 78V81H12V78C12 51.5325 33.5325 30 60 30C86.4675 30 108 51.5325 108 78H102C102 54.84 83.16 36 60 36C36.84 36 19.65 53.2375 18.105 75H27.135C28.655 58.2025 42.815 45 60 45C78.1975 45 93 59.8025 93 78V81Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperflex);
export default __webpack_public_path__ + "static/media/Superflex.855a3364.svg";
export { ForwardRef as ReactComponent };